import { render, staticRenderFns } from "./ResultRow.vue?vue&type=template&id=28131f0e&scoped=true"
import script from "./ResultRow.vue?vue&type=script&lang=js"
export * from "./ResultRow.vue?vue&type=script&lang=js"
import style0 from "./ResultRow.vue?vue&type=style&index=0&id=28131f0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28131f0e",
  null
  
)

export default component.exports